import _ from 'lodash';
import { RealtimeRole } from '@doxyme/realtime';
import { setApolloSessionStorageData } from 'utility/sessionStorage/actions';
import RealTimeActions from './realtime-actions';
import { EndCallReasons } from '../../common/services/doxy-analytics/tracks/video-session-end';
import { VideoChatRealtimeMessageTypes, CallNotifications, } from '../../video-chat/video-chat.realtime-component';
import { RootScopeEvents } from 'common/services/root-scope-types';
import * as notifications from '../../modules/notifications';
export default class PatientRealtimeActions extends RealTimeActions {
    /* @ngInject */
    constructor($timeout, pn, activeComponents, $log, globalUi, $rootScope, $location, VideoQualityService, VideoProviderFactory, notificationFactory, communicationControl, downgradeCallStateService, roomHelpersFactory, routerHelperFactory, intercomFactory, v2, $ngRedux) {
        super(activeComponents, $log, pn, $timeout);
        this.pn = pn;
        this.activeComponents = activeComponents;
        this.$log = $log;
        this.globalUi = globalUi;
        this.$rootScope = $rootScope;
        this.$location = $location;
        this.VideoQualityService = VideoQualityService;
        this.VideoProviderFactory = VideoProviderFactory;
        this.notificationFactory = notificationFactory;
        this.communicationControl = communicationControl;
        this.downgradeCallStateService = downgradeCallStateService;
        this.roomHelpersFactory = roomHelpersFactory;
        this.routerHelperFactory = routerHelperFactory;
        this.intercomFactory = intercomFactory;
        this.v2 = v2;
        this.$ngRedux = $ngRedux;
        this.patientCaptionsEnabled = false;
        this.extensionsPathMap = {
            payment: './payment/patient.js',
            screenshare: './screensharing/patient.js',
        };
        this.onLeaveComponentNames = [
            'payment',
            'screenshare',
            'fileTransfer',
            'teleconsent',
        ];
    }
    onMessage(data, person) {
        const { componentName, action } = data.message;
        this.$log.debug(`mediator:message:${componentName}:${action}`, data, person);
        switch (`message:${componentName}:${action}`) {
            case `message:phone:${VideoChatRealtimeMessageTypes.INIT}`: {
                this.onPhoneCallInit(data.message);
                break;
            }
            case 'message:phone:start': {
                this.onPhoneStart(data.message, person);
                break;
            }
            case 'message:phone:startv2': {
                this.onStartV2(data.message);
                break;
            }
            case 'message:phone:end': {
                this.onPhoneEnd(data.message);
                break;
            }
            case 'message:phone:restart': {
                this.onPhoneRestart(data.message);
                break;
            }
            case 'message:global:removedFromWaitingRoom': {
                this.onRemovedFromWaitingRoom(data.message);
                break;
            }
            case 'message:global:initTransferToAnotherRoom': {
                this.onInitTransferToAnotherRoom(data.message, person);
                break;
            }
            case `message:phone:${VideoChatRealtimeMessageTypes.CHANGE_VIDEO_QUALITY}`: {
                this.onVideoQualityChange(data.message);
                break;
            }
            case `message:phone:${VideoChatRealtimeMessageTypes.CHANGE_AUDIO_TYPE}`: {
                this.onAudioTypeChange(data.message);
                break;
            }
            case 'message:phone:downgradeToAudio': {
                this.onDowngradeToAudio();
                break;
            }
            case 'message:phone:connectionImproved': {
                this.onConnectionImprove();
                break;
            }
            default: {
                this.onExtension(data.message, person);
                break;
            }
        }
    }
    onVideoQualityChange(message) {
        this.VideoQualityService.switchTo(message.content.quality).catch((err) => {
            console.warn('Switch video quality error:', err);
        });
    }
    onAudioTypeChange(message) {
        this.VideoProviderFactory.activeProvider.changeAudioType(message.content.audioType);
    }
    onRemovedFromWaitingRoom(message) {
        this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.REMOVED_FROM_ROOM);
        this.communicationControl.phoneStop();
        this.notificationFactory.showCommon('info', message.content.notificationMessage, null, notifications.constants.HIDE_DELAY_BY_END_CALL);
        this.$rootScope.$emit('removeCurrentPatientFromWaitingRoom');
    }
    onInitTransferToAnotherRoom(message, person) {
        if (Boolean(message.content?.transferRoomUrl)) {
            localStorage.setItem('transfer-sender-id', person.getUserId().toString());
            localStorage.setItem('patient-transfer-notify-key', message.content.transferNotifyKey.toString());
            localStorage.setItem('should-show-transfer-toast', 'true');
            const roomUrl = new URL(message.content.transferRoomUrl);
            roomUrl.searchParams.set('username', this.pn.globalState.username);
            roomUrl.searchParams.set('autocheckin', 'true');
            roomUrl.searchParams.set('transfer', 'true');
            roomUrl.searchParams.set('fromRoomId', this.roomHelpersFactory.getRoom().id);
            if (Boolean(message.content.pid)) {
                roomUrl.searchParams.set('pid', message.content.pid);
            }
            void this.pn.stop();
            window.location.href = roomUrl.toString();
        }
    }
    onPhoneCallInit(message) {
        /*
          If the doctor explicitly starts an audio call, we must show the patient a message about
          the initialization of the audio call, regardless of the media permissions he has set.
          But in the case of a call restart, this should be ignored,
          because the participants should receive a call restarting message.
        */
        const isAudioOnly = _.get(message, 'content.options.audioOnly', false);
        const isInitialCall = !this.globalUi.ui.isRestartingCall;
        // eslint-disable-next-line @typescript-eslint/no-unnecessary-condition
        if (isAudioOnly && isInitialCall) {
            this.$rootScope.$emit(RootScopeEvents.VIDEO_CHAT_LOADING_SCREEN.UPDATE_MESSAGE, 'session.audio-call-initialize');
        }
        this.globalUi.startCall();
    }
    onPhoneRestart(message) {
        if (Boolean(message.content.notification)) {
            this.notificationFactory.showCommon('info', message.content.notification, 'onPhoneRestart', 5000);
        }
        if (Boolean(message.content.loaderMessage)) {
            this.$rootScope.$emit('video-chat-loading-screen:update-message', message.content.loaderMessage);
            if (message.content.loaderMessage === 'session.call-switch-to-routed') {
                this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.RESTART_FOR_GROUP);
            }
            else {
                this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.RESTARTED);
            }
        }
        this.activeComponents.phone.isRestartingCall = true;
        this.globalUi.ui.isRestartingCall = true;
        this.communicationControl.phoneStop();
        this.globalUi.startCall();
    }
    onStartV2(pnMessage) {
        if (this.pn.globalState.status !== 'available') {
            return;
        }
        this.intercomFactory.shutdown();
        const { sessionId, vendor, joinedParticipantsIds = [], isAudioCall, } = pnMessage.content;
        const referrer = window.location.pathname;
        const chatHistory = this.activeComponents.chat.history;
        setApolloSessionStorageData({
            sessionId,
            referrer,
            role: RealtimeRole.Patient,
            vendor,
            navigationStarted: Date.now(),
            rooms: this.roomHelpersFactory.getPersonalRooms(),
            roomId: this.roomHelpersFactory.getRoom().id,
            chatHistory,
            identityId: this.pn.getUuid(),
            joinedParticipantsIds,
            isAudioCall,
        });
        void this.pn.stop().finally(() => {
            void this.v2.redirect('/call/');
        });
    }
    onPhoneStart(pnMessage, person) {
        if (this.pn.globalState.status !== 'available') {
            return;
        }
        if (person.isDoctor()) {
            if (person.state.quality) {
                void this.VideoQualityService.switchTo(person.state.quality);
            }
            this.VideoProviderFactory.activeProvider.changeAudioType(pnMessage.content.audioType);
        }
        this.communicationControl.answerPhone(pnMessage.content, person);
        if (Boolean(this.activeComponents.chat.minimized)) {
            this.activeComponents.chat.openChat(person, false);
        }
    }
    onPhoneEnd(message) {
        this.notificationFactory.showCommon('info', message.content.notification);
        const isHold = message.content.notification === CallNotifications.Hold;
        if (isHold) {
            this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.PAUSED);
        }
        else {
            /**
             * @todo investigate wether EndCallReasons.DOCTOR_CANCEL is needed.
             */
            this.$rootScope.$emit('activeProvider:endReason', EndCallReasons.DOCTOR_CANCEL);
        }
        this.communicationControl.phoneStop(message.content.notification);
    }
    onDowngradeToAudio() {
        this.downgradeCallStateService.downgradeToAudioOnly({
            currentPersonIsCulprit: true,
        });
    }
    onConnectionImprove() {
        this.downgradeCallStateService.connectionImproved();
    }
    /**
     * Patient signals to the provider when they want to toggle captions
     */
    signalCaptionsToggle(enabled) {
        this.patientCaptionsEnabled = enabled;
        const doctor = this.VideoProviderFactory.activeProvider.peopleCollection?.getDoctors()[0];
        const status = enabled ? 'on' : 'off';
        this.sendToTarget(doctor, {
            componentName: 'phone',
            action: VideoChatRealtimeMessageTypes.CAPTIONS_TOGGLE,
            content: {
                status,
            },
        });
    }
    /**
     * Returns whether the patient currently has captions enabled
     */
    get isCaptionsEnabled() {
        return this.patientCaptionsEnabled;
    }
}
